import React from "react"

const Home = () => 
    <h2> 
        This is home page!
    </h2>

export default Home;